import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Coding is bad for you",
  "description": "",
  "published": "2018-03-16T00:00:00.000Z",
  "redirect_from": ["/blog/coding-bad/swizec/8287"],
  "categories": "Personal, Thoughts",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`To achieve happiness 👇`}</p>
    <ol>
      <li parentName="ol">{`Stop coding`}</li>
      <li parentName="ol">{`Repeat until happy`}</li>
    </ol>
    <p>{`Coding is terrible for your mental health. It makes you focus on things that can go wrong, find faults in tiny details, and generally focus on the negative aspects.`}</p>
    <p>{`When something works, you think, `}<em parentName="p">{`"That's strange, usually things don't work. What am I missing?"`}</em></p>
    <p>{`And you get frustrated with things you can't control. Like people. You try to analyze them like computers. You get frustrated with how longwinded they are. They ramble.`}</p>
    <p>{`And the more time you spend coding, the more you realize that computer systems never work. They’re too complex, and there are too many hidden assumptions, too many things that can go wrong, too many things that DO go wrong. Large computer systems are `}<em parentName="p">{`always`}</em>{` going to have bugs. Big bugs. Bugs nobody noticed. Bugs nobody even knows exist yet.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2018/03/tim-gouw-68319-unsplash-1024x685.jpg",
        "alt": null
      }}></img></p>
    <p>{`Sometimes you see code, and you think, `}<em parentName="p">{`"How did this ever work?"`}</em></p>
    <p>{`How many codes out there are like that? `}<em parentName="p">{`”How did this ever work?”`}</em>{` someone will say when it goes wrong and a trading bot wipes a few billion dollars off the stock exchange or crashes a Mars lander into a mountain.`}</p>
    <p>{`The world runs on computers.`}</p>
    <p>{`How are we even still alive?`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      